export default __webpack_public_path__ + "static/media/checked.d413ba75.svg";